module.exports = __webpack_public_path__ + "img/icon_h-car-rental.cedc262b.png";